export function setSessionStorage(key, data = []) {
  sessionStorage.setItem(key, JSON.stringify(data));
}

export function getSessionStorage(key) {
  return sessionStorage?.getItem(key);
}
